<template>
    <div>
        <el-row class="searchSection">
            <el-form ref="form" :inline="true" :model="searcheModel" class="external-form">
                <el-form-item label="汇算月份">
                    <el-date-picker
                    size="small"
                    v-model="searcheModel.months"
                    type="monthrange"
                    format="yyyy-MM"
                    value-format="yyyy-MM"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    >
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="所属部门">
                    <UserCascader
                    v-model="searcheModel.branch_id"
                    ref="branch"
                    :isBusiness="true"
                    @change="changeBranch"
                    ></UserCascader>
                </el-form-item>
                <el-form-item label="部门负责人" v-if="searcheModel.count_type == 1">
                    <BranchLeader ref="leader" @change="changeLeader"></BranchLeader>
                </el-form-item>
                <el-form-item label="业务员" v-else-if="searcheModel.count_type == 2">
                    <UserSelect ref="user" @change="changeUser"></UserSelect>
                </el-form-item>
                <el-form-item label="过滤销售额为0的订单">
                    <el-select size="small" v-model="searcheModel.not_have_amount" placeholder="请选择">
                        <el-option label="不限" value=""></el-option>
                        <el-option label="是" value="1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="small" @click="submitSearch">开始汇算</el-button>
                    <el-button @click="resetForm()" size="small">重置</el-button>
                    <ExportFile 
                    v-if="Acs('/performance-calc/' + activeName)"
                    :url="'/api/export/' + activeName" 
                    :params="searcheModel" 
                    :filename="activeName == 'sale-bonus' ? '销售提成业绩' : '绩效激励业绩'" 
                    buttonName="导出Excel">
                    </ExportFile>
                </el-form-item>
            </el-form>
        </el-row>
        <el-row class="searchSection">
            <el-col :span="22">
                <el-tabs type="card" v-model="searcheModel.count_type" @tab-click="handleClick">
                    <el-tab-pane label="按部门" name="1"></el-tab-pane>
                    <el-tab-pane label="按成员" name="2"></el-tab-pane>
                </el-tabs>
            </el-col>
            <el-col :span="2">
                <CountConfig v-if="Acs('/count-config/view')" :path="$route.path" :tab="activeName" type="settle"></CountConfig>
            </el-col>
        </el-row>
        <p style="color:#85CE61;">
            统计说明：<br>
            1. 非代理代签订单：当月业绩=当月上传合同或回款的订单业绩<br>
            2. 代理单、代理代签订单：当月的业绩=当月录单的订单业绩<br>
            3. 协作单已按照业务员个人业绩占比拆分
        </p>
        <div v-loading="loading">
            <el-table 
            v-if="!loading"
            :data="list" 
            border 
            height="650"
            row-key="id" 
            :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
            :header-cell-style="{background: '#f3faff'}"
            :summary-method="getSummaries"
            show-summary
            >
                <template v-if="searcheModel.count_type == 1">
                    <el-table-column prop="name" label="部门" width="200"></el-table-column>
                    <el-table-column prop="leader_name" label="部门负责人"></el-table-column>
                </template>
                <template v-else>
                    <el-table-column prop="name" label="业务员"></el-table-column>
                    <el-table-column prop="branch_name" label="所属部门"></el-table-column>
                </template>
                <el-table-column prop="performance" label="新增业绩"></el-table-column>
                <el-table-column prop="renew" label="续费业绩"></el-table-column>
                <el-table-column prop="proxy_performance">
                    <template slot="header">
                        <!-- 自定义表头 -->
                        <span>代理新增业绩</span>
                        <el-tooltip class="item" effect="dark" content="签单模式为代理自签单的新增业绩" placement="top">
                            <i class="el-icon-info"></i>
                        </el-tooltip>
                    </template>
                    <template slot-scope="scope">
                        {{ scope.row.proxy_performance }}
                    </template>
                </el-table-column>
                <el-table-column prop="proxy_renew">
                    <template slot="header">
                        <!-- 自定义表头 -->
                        <span>代理续费业绩</span>
                        <el-tooltip class="item" effect="dark" content="签单模式为代理自签单的续费业绩" placement="top">
                            <i class="el-icon-info"></i>
                        </el-tooltip>
                    </template>
                    <template slot-scope="scope">
                        {{ scope.row.proxy_renew }}
                    </template>
                </el-table-column>
                <el-table-column prop="stop_renew" label="断续新增业绩"></el-table-column>
                <el-table-column prop="total_amount" label="合同金额"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="handleView(scope.row)">查看</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
  </template>
  <style scoped>
  
  </style>
  <script>
  import PerformanceCalcCount from "~/services/PerformanceCalcCount";
  import UserCascader from "~/widgets/UserCascader.vue";
  import UserSelect from "~/widgets/UserSelect.vue";
  import BranchLeader from "~/widgets/BranchLeader.vue";
  import Config from "~/config/params";
  import ExportFile from "~/widgets/ExportFile.vue";
  import CountConfig from "~/widgets/CountConfig.vue";
  export default {
    name: "saleBonus",
  
    components: {
        UserCascader,
        UserSelect,
        Config,
        ExportFile,
        CountConfig,
        BranchLeader
    },
  
    props: {
        activeName: {
            type: String,
            default: ''
        }
    },
  
    data() {
        return {
            loading: false,
            searcheModel: {},
            // 分页信息
            linkPage: null,
            list: [],
        };
    },
  
    mounted() {
        this.resetForm();
    },
  
    created() {
        
    },
  
    methods: {
        //重置按钮
        resetForm() {
            this.searcheModel = {
                branch_id: "",
                user_id: "",
                count_type: '1',
                months: Config.getDataTimes('this_month'),
                path: this.$route.path,
                tab: this.activeName,
                not_have_amount: '',
            };
            if(this.$refs['user']){
                this.$refs['user'].reset();
            }
            if(this.$refs['leader']){
                this.$refs['leader'].reset();
            }
            if(this.$refs['branch']){
                this.$refs['branch'].reset();
            }
            this.list = [];
            this.submitSearch();
        },
    
        // 筛选查询
        submitSearch() {
            let params = _.clone(this.searcheModel);
            _.each(params, (val, key) => {
                // 如果值是假值，除了数字 0 和字符串 '0'，都删除该键
                if (val === undefined || val === null || (typeof val === 'string' && val === '')) {
                    delete params[key];
                }
            })
            this.getList(params);
        },
    
        //获取列表
        getList(params) {
            // loading 动画
            this.loading = true;
            PerformanceCalcCount.getList(params, this.activeName).then((res) => {
                if (res.code == 0) {
                    this.list = res.data;
                }
                if (res._meta) {
                    this.linkPage = res._meta;
                }
                this.loading = false;
            }).catch((err) => {
                console.error(err);
                this.loading = false;
            });
        },
    
        //切换业务员子组件
        changeUser(object) {
            this.searcheModel.user_id = object.label;
        },

        changeLeader(val){
            this.searcheModel.branch_id = val;
        },

        //切换部门子组件
        changeBranch(value) {
            if (value.length > 0) {
                // 取得最后一级部门作为所属部门
                this.searcheModel.branch_id = value[value.length - 1];
            } else {
                this.searcheModel.branch_id = "";
            }
        },

        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                // 第一列不计算合计，显示自定义的文字内容
                if (index === 0) {
                    sums.push('合计：' + data.length + '条');
                    return;
                }
                // 初始化合计值为0
                let sum = 0;
                // 遍历数据，累加顶级行的值
                data.forEach(item => {
                    // 累加当前项的值，注意转换为数字
                    sum += Number(item[column.property]);
                });
                // 如果所有值都是数字，则显示合计结果，否则显示'-'
                if (!isNaN(sum)) {
                    sums.push(Math.round(sum * 100) / 100); // 保留两位小数
                } else {
                    sums.push('--');
                }
            });
            return sums;
        },

        // 查看
        handleView(row) {
            let query = _.clone(this.searcheModel);
            if(row.hasOwnProperty('user_id')){
                query['user_id'] = row.user_id;
            }else{
                query['branch_id'] = row.branch_id;
            }
            query['is_confirm'] = '1';
            // console.log('查看：', query);
            this.$emit("handleView", query);
        },

        handleClick(){
            this.searcheModel.user_id = '';
            this.submitSearch();
        },
    },
  };
  </script>


// WEBPACK FOOTER //
// src/views/count/performance/SaleBonus.vue